import { DiceIcon } from "@/shared/icons";
import { Button, Icon } from "@/shared/ui";

type Props = {
  title: string;
  onRandom: () => void;
};

export default function CreateCharacterStepHeader({ title, onRandom }: Props) {
  return (
    <div className="text-xl font-bold mb-3 flex justify-between items-center">
      {title}
      <Button
        className="h-9.5 pl-3 pr-2.5 text-15 normal-case"
        onClick={onRandom}
        variant="solid-surface-gradient"
      >
        Случайно
        <DiceIcon size={20} className="ml-2 shrink-0" />
      </Button>
    </div>
  );
}
